module.exports = {
          srcSet: __webpack_public_path__ + "675cb4f1064d5fff00579b0c10ad6c7b-583.png"+" 583w",
          images:[ {path: __webpack_public_path__ + "675cb4f1064d5fff00579b0c10ad6c7b-583.png",width: 583,height: 245}],
          src: __webpack_public_path__ + "675cb4f1064d5fff00579b0c10ad6c7b-583.png",
          toString:function(){return __webpack_public_path__ + "675cb4f1064d5fff00579b0c10ad6c7b-583.png"},
          
          width: 583,
          height: 245
        }